import createActionSet from 'utils/createActionSet';

const namespace = 'DIAMOND';
const GET_DIAMOND = createActionSet(namespace, 'GET_DIAMOND');

export const DIAMONDS_ACTION_TYPES = {
  GET_DIAMOND,
};
